import plusFill from '@iconify/icons-eva/close-circle-outline';
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
// material
import { Button, Container, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';

//
// components
import { AerosForm } from '../components/Aeros';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { useTranslation } from '../common/LocalizationProvider';
import { selectAerosArray } from '../createSelectorUtils';
// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function EditAero() {
  const t = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const aero = useSelector(selectAerosArray).find(
    (item) => item.id === (location.state !== null ? location.state.id : 0)
  );

  return (
    <Page title={t('AE_Title')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('edit_aeros')}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate(-1)}
            startIcon={<Icon icon={plusFill} />}
            color="secondary"
          >
            {t('btn_Cancel')}
          </Button>
        </Stack>
        <Scrollbar>
          <ContentStyle>
            <AerosForm aeroId={location.state !== null ? location.state.id : 0} aero={aero} />
          </ContentStyle>
        </Scrollbar>
      </Container>
    </Page>
  );
}
